import { useParams } from 'react-router-dom';
import cn from 'bem-cn';

import { Stack } from '../../../components/UI';
import { NoPromptsBanner } from '../../../components/NoPromptsBanner';
import { Feed } from '../../../components/Feed';
import { usePromptFeedColumns } from '../../HomePage/HomePage.hooks';
import { useInfiniteScroll } from '../../../hooks/useInfiniteScroll';
import { useUserPromptsFeed } from './useUserPromptsFeed';

import './ProfilePrompts.scss';

const b = cn('profile-prompts');

export const ProfilePrompts = () => {
    const { loginOrPublicId } = useParams<{ loginOrPublicId: string }>();

    const {
        prompts: userPrompts,
        loading: isFetching,
        hasMore,
        loadMore,
        isSuccess,
    } = useUserPromptsFeed(loginOrPublicId || '', 20);

    // Настройка infinite scroll
    useInfiniteScroll(loadMore, {
        threshold: 600,
        enabled: true,
        hasMore,
        loading: isFetching,
    });

    const columns = usePromptFeedColumns();
    const correctedColumns = Math.min(columns, Math.max(2, userPrompts.length));

    const getSectionSize = () => {
        if (userPrompts.length < 3) {
            return 'small';
        }

        if (userPrompts.length === 3) {
            return 'medium';
        }

        return 'large';
    };

    return (
        <Stack spacing={24} className={b({ size: getSectionSize() })}>
            <div className={b('header')}>
                <h2>Промпты</h2>
            </div>
            <div className={b('content')}>
                {isSuccess && userPrompts.length === 0 ? (
                    <NoPromptsBanner />
                ) : (
                    <Feed prompts={userPrompts} columns={correctedColumns} isLoading={isFetching} hasMore={hasMore} />
                )}
            </div>
        </Stack>
    );
};
